import { formatMoney, toCentsFromString, toMoney } from '@betterment/core';

export function toCentsFromDollarString(v: string) {
  const numberString = v.replace(/\$|,/gi, '');
  return toCentsFromString(numberString);
}

export function toDollarStringFromCents(v: number): string {
  return formatMoney(toMoney(v));
}
